import { getEnv } from '@atlassian/pillar/runtime/env';

// Use a getter function to safely access window.location.origin
// This prevents issues in test environments where window might not be available
export const getDefaultTenantBaseUrl = (): string => {
	if (typeof window !== 'undefined' && window.location) {
		return window.location.origin;
	}
	return 'https://teamwork-graph.atlassian.com'; // fallback for test environments
};

/**
 * PROD: https://hello.atlassian.net
 */
const HELLO_CLOUD_ID_PROD = 'a436116f-02ce-4520-8fbb-7301462a1674';
export const HELLO_ORG_ID_PROD = '2346a038-3c8c-498b-a79b-e7847859868d';

/**
 * STG: https://atlassian-studio-playground-experience.jira-dev.com
 */
const STUDIO_PLAYGROUND_CLOUD_ID_STG = 'ff4f56fc-6582-4084-941c-c0d04c0ab3f9';
export const DEFAULT_TENANT_BASE_URL: string = getDefaultTenantBaseUrl();
const DEFAULT_LABS_CLOUD_ID: 'a436116f-02ce-4520-8fbb-7301462a1674' = HELLO_CLOUD_ID_PROD;
/**
 * PROD: https://one-atlas-qdiv.atlassian.net
 */
const DEFAULT_QUERY_BUILDER_CLOUD_ID = 'a32e5600-cd47-41af-9fa5-ca64b7866880';
export const DEFAULT_QUERY_BUILDER_QUERY_CONTEXT: 'ari:cloud:platform::site/a32e5600-cd47-41af-9fa5-ca64b7866880' = `ari:cloud:platform::site/${DEFAULT_QUERY_BUILDER_CLOUD_ID}`;

// PUG staging cloud ID — UGS can't determine an org from a user ARI alone,
// so staging consumers must pass the PUG site ARI as X-Query-Context.
export const PUG_CLOUD_ID_STG = 'DUMMY-a5a01d21-1cc3-4f29-9565-f2bb8cd969f5';
export const PUG_ORG_ID_STG = '3f97e0d7-a8ca-4263-91bf-3015999c8e64';

/**
 * Get the appropriate cloud ID based on the environment
 */
const getDefaultTenantCloudId = (): string => {
	const env = getEnv();
	// Use staging cloud ID for local and staging environments
	if (env === 'local' || env === 'development' || env === 'staging') {
		return STUDIO_PLAYGROUND_CLOUD_ID_STG;
	}
	// Use production cloud ID for production
	return DEFAULT_LABS_CLOUD_ID;
};

export const DEFAULT_TENANT_CLOUD_ID: string = getDefaultTenantCloudId();
